import { register } from 'swiper/element/bundle';

let swiperElementsRegistered = false;

export function registerSwiperElements(): void {
  if (swiperElementsRegistered) {
    return;
  }

  register();
  swiperElementsRegistered = true;
}